(function(){
  var STORAGE_KEY = 'ccdLangSuggestDismissedAt';
  var SNOOZE_DAYS = 30;

  function dismissedRecently(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      if(!v) return false;
      var days = (Date.now() - parseInt(v, 10)) / 86400000;
      return days < SNOOZE_DAYS;
    }catch(e){ return false; }
  }

  if(dismissedRecently()) return;

  var root = document.getElementById('ccd-lang-suggest');
  if(!root) return;

  var strings = window.ccdLangSuggestStrings || {};
  var htmlLang = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
  var isJaSite = htmlLang.indexOf('ja') === 0;
  var browserLang = (navigator.language || (navigator.languages && navigator.languages[0]) || 'en').toLowerCase();
  var prefersJa = browserLang.indexOf('ja') === 0;

  if(prefersJa === isJaSite) return; // already on the preferred language

  var code = prefersJa ? 'ja' : 'en';
  var msg = prefersJa ? strings.toJaMsg : strings.toEnMsg;
  var btn = prefersJa ? strings.toJaBtn : strings.toEnBtn;
  if(!msg || !btn) return;

  var codeInput = document.getElementById('ccd-lang-suggest-code');
  var msgEl = document.getElementById('ccd-lang-suggest-msg');
  var goEl = document.getElementById('ccd-lang-suggest-go');
  var closeEl = document.getElementById('ccd-lang-suggest-close');
  if(codeInput) codeInput.value = code;
  if(msgEl) msgEl.textContent = msg;
  if(goEl) goEl.textContent = btn;

  root.hidden = false;
  requestAnimationFrame(function(){ root.classList.add('is-visible'); });

  function dismiss(){
    root.classList.remove('is-visible');
    try{ localStorage.setItem(STORAGE_KEY, String(Date.now())); }catch(e){}
    setTimeout(function(){ root.hidden = true; }, 300);
  }
  if(closeEl) closeEl.addEventListener('click', dismiss);
})();
